// extracted by mini-css-extract-plugin
export default {"root":"wWVa4","link":"UVCRG","bodyText":"myoX2","button":"hhAd0","header":"eb9WA","body":"a3JXy"};